const Profile = () => import(/* webpackPrefetch: true */ '@/views/private/Profile.vue')
const Owner = () => import(/* webpackPrefetch: true */ '@/components/profile/Owner.vue')
const Company = () => import(/* webpackPrefetch: true */ '@/components/profile/Company.vue')

const routes = [
  {
    path: "/profile",
    name: "profile",
    component: Profile,
    meta: {
      title: "Profil"
    },
    children: [
      {
        path: '/profile/owner',
        name: 'profile owner',
        component: Owner,
        meta: {
          title: "Profil General"
        }
      },
      {
        path: '/profile/company',
        name: 'profile company',
        component: Company,
        meta: {
          title: "Perusahaan"
        }
      }
    ]
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})